import React from "react";
import styles from "../../static/css/pages.module.css";
import Title from "../../components/title/title";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import ProfileMain from "./profile_main";
import ProfileDetails from "./profile_details";
import * as consts from "../../store/constants/userInfo";
import {getInfoAction} from "../../store/actions/getInfoAction";
import {connect} from "react-redux";
import ieSvg from "../../components/icons/ieSvg";

class PageSettings extends React.Component {
  componentDidMount() {
    ieSvg();
    document.title = "Настройки профиля | Самозанятые";
    if (this.props.data.items) return;
    this.props.fetchData(process.env.REACT_APP_GATE + "client/details", this, consts.CLIENT_DETAILS);
  }

  render () {
    return (
      <div className={styles.content}>
        <div className="l-grid_pt-8 mobile_l-grid">
          <div className="l-grid__item_1"/>
          <div className="l-grid__item_6 mobile_l-grid__item_10 l-position_relative">
            <Title icon="icon_menu-clients" title="Настройки профиля"/>
            <Tabs>
              <TabList>
                <Tab>Личные данные</Tab>
                <Tab>Информация о статусе</Tab>
              </TabList>

              <TabPanel>
                <ProfileMain />
              </TabPanel>
              <TabPanel>
                <ProfileDetails details={this.props} />
              </TabPanel>
            </Tabs>

          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({data: state.clientDetails})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types) => dispatch(getInfoAction(url, parent, types))}
}

export default connect(mapStateToProps, mapDispatchToProps)(PageSettings);